/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular
  .module('app.services')
  .factory('jobsService', ['$http', function($http) {

    const CATEGORY = {
      "regular": "1",
      "custom": "2",
      "connect": "3",
      "speculative": "4",
      "ats": "5"
    };

  	let instance = {
      setJobCategory: (jobs) => {
        jobs.forEach( job => {
           
          Object.assign( job, {
            isSpeculative: false,
            is_connected: false,
            is_custom: false
          });

          if ( Object.is( job.jobCategory,  CATEGORY.custom) ) {
            job.is_custom = true;
          }else if ( Object.is(job.jobCategory , CATEGORY.connect) ) {
            job.is_connected = true;
          }else if (Object.is(job.jobCategory , CATEGORY.speculative) ) {
            job.isSpeculative = true;
          }

        });
      }
  	};

  	return instance;
  }]);



// WEBPACK FOOTER //
// ./scripts/shared/services/jobs.js